module.exports = __webpack_public_path__ + "img/cast.03a98e58.svg";